import * as Preact from 'preact';

/** methods for controling the application */
export interface AppControl {
    closeApp: () => void;
    /** provide a name and a function to be called when the app is triggered to close */
    enhanceCloseApp: (tag: string, enhancer: () => void) => void;
}

/** Provide functions to control the app window  */
export const AppControlContext = Preact.createContext<AppControl | undefined>(undefined);
